import "./App.css";
import Header from "./header/Header";
import Contact from "./contact/Contact";
import Infoskill from "./infoskills/Infoskill";
import Eduexp from "./eduexp/Eduexp";

function App() {
  return (
    <div>
      <Header />
      <Contact />
      <Infoskill />
      <Eduexp />
    </div>
  );
}

export default App;
